import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4df1182"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "actions" }
const _hoisted_2 = {
  key: 1,
  class: "my-2 pa-2 px-4"
}
const _hoisted_3 = { class: "pa-4" }
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "mt-6 text-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_LangSwitch = _resolveComponent("LangSwitch")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createBlock(_component_v_main, { class: "bg-teal-lighten-3 d-flex flex-column justify-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, {
        fluid: "",
        class: "text-center"
      }, {
        default: _withCtx(() => [
          (!$data.isLoading)
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 0,
                "max-width": "500",
                class: "mx-auto bg-teal-lighten-5"
              }, {
                default: _withCtx(() => [
                  ($data.mode !== 'onboarding')
                    ? (_openBlock(), _createBlock(_component_v_form, {
                        key: 0,
                        class: "my-2 pa-2 px-4",
                        onSubmit: _withModifiers($options.submitData, ["prevent"]),
                        "validate-on": "blur",
                        ref: "form"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            type: "email",
                            modelValue: $data.userMail,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.userMail) = $event)),
                            modelModifiers: { trim: true },
                            rules: $data.emailRules,
                            label: _ctx.$t('auth.inputs.mail'),
                            required: "",
                            class: "pb-2",
                            variant: "solo",
                            autocomplete: "email"
                          }, null, 8, ["modelValue", "rules", "label"]),
                          _createVNode(_component_v_text_field, {
                            type: "password",
                            modelValue: $data.userPassword,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.userPassword) = $event)),
                            modelModifiers: { trim: true },
                            rules: $data.passwordRules,
                            label: _ctx.$t('auth.inputs.password'),
                            required: "",
                            class: "pb-2",
                            variant: "solo",
                            autocomplete: "current-password"
                          }, null, 8, ["modelValue", "rules", "label"]),
                          _createElementVNode("div", _hoisted_1, [
                            _createVNode(_component_v_btn, {
                              variant: "tonal",
                              color: "teal",
                              type: "submit",
                              disabled: !$options.hasEnteredData
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($options.submitButtonCaption), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"]),
                            _createVNode(_component_v_btn, {
                              variant: "outlined",
                              color: "teal",
                              type: "button",
                              onClick: $options.switchAuthMode
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($options.switchModeButtonCaption), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_LangSwitch, { class: "lang-switch" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["onSubmit"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('onboarding.title')), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t('onboarding.subtitle')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_v_btn, {
                            variant: "tonal",
                            color: "teal",
                            onClick: $options.addDefaultContacts
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('onboarding.addBtnTitle')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_v_btn, {
                            variant: "outlined",
                            color: "teal",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.replace('/')))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('onboarding.noAddBtnTitle')), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_BaseSpinner, { color: "white" }),
                _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t('auth.info.loading')), 1)
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}